export default __webpack_public_path__ + "static/media/confirmation.d03b9996.png";